document.documentElement.classList.remove('no-js');

(() => {
  const toggles = document.querySelectorAll('[data-menu-toggle]');
  toggles.forEach((toggle) => {
    toggle.addEventListener('click', () => {
      const target = document.querySelector(toggle.getAttribute('data-menu-toggle'));
      if (!target) return;
      const open = target.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  document.querySelectorAll('[data-mega-toggle]').forEach((button) => {
    const id = button.getAttribute('aria-controls');
    const panel = document.getElementById(id);
    if (!panel) return;

    const close = () => {
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      const open = button.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('[data-mega-toggle]').forEach((b) => {
        if (b !== button) {
          b.setAttribute('aria-expanded','false');
          const p = document.getElementById(b.getAttribute('aria-controls'));
          if (p) p.hidden = true;
        }
      });
      button.setAttribute('aria-expanded', open ? 'false' : 'true');
      panel.hidden = open;
    });

    document.addEventListener('click', (event) => {
      if (!panel.hidden && !panel.contains(event.target) && !button.contains(event.target)) close();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  });

  document.querySelectorAll('[data-faq-button]').forEach((button) => {
    button.addEventListener('click', () => {
      const item = button.closest('[data-faq-item]');
      if (!item) return;
      const open = item.classList.toggle('is-open');
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
})();
